import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Mutations } from "@/store/enums/StoreEnums";

@Module({ name: "languageGlobalSelectionModule" })
export default class LanguageGlobalSelectionModule extends VuexModule {
  private language = localStorage.getItem("lang");

  get selectedLanguage(): any {
    return this.language;
  }

  @Mutation
  [Mutations.SET_LANGUAGE](languageValue: string): void {
    this.language = languageValue;
  }
}
